import qs from "qs";
import { useState } from "react";
import { useLocation } from "react-router";
import { post } from "../../api";
import { CHANGE_NEWSLETTER_AGREEMENT, NEWSLETTER_AGREEMENT, RESIGN_FROM_NEWSLETTER } from "../../api/apiRoutes";
import useFacility from "../../../utils/hooks/useFacility";
import { errorMessageFromApi } from "../../utils/apiErrorMessages";

export const NEWSLETTER_CONFIMRATION_SUCCESS = "NEWSLETTER_CONFIMRATION_SUCCESS";
export const NEWSLETTER_CONFIMRATION_WAITING = "NEWSLETTER_CONFIMRATION_WAITING";

const getFacilityIdsFromUrl = (search: string): string | undefined => {
  const query = qs.parse(search.startsWith("?") ? search.slice(1) : search);
  const rawValue = query.id ?? query.ids ?? query.facilityIds;
  const facilityId = Array.isArray(rawValue) ? rawValue[0] : rawValue;

  if (typeof facilityId !== "string" || facilityId.length === 0) {
    return undefined;
  }

  let normalized = facilityId.includes("/") ? facilityId.split("/")[0] : facilityId;
  if (normalized.startsWith("0,")) {
    normalized = normalized.substring(2);
  }

  return normalized;
};

/* eslint-disable import/no-anonymous-default-export */
export default () => {
  const [status, setStatus] = useState<string>(NEWSLETTER_CONFIMRATION_WAITING);
  const [alert, setAlert] = useState("");
  const [error, setError] = useState("");
  const location = useLocation();
  const facilityFromStore = useFacility();
  const facilityIds = getFacilityIdsFromUrl(location.search) || facilityFromStore;
  const hash = qs.parse(location.search.slice(1), {
    decoder: (str, decoder, charset, type) => {
      if (type === "value" || type === "key") {
        return decodeURIComponent(str);
      }
      return str;
    },
  }).hash as string;

  const onConfirm = async () => {
    setError("");
    const response = await post(CHANGE_NEWSLETTER_AGREEMENT(facilityIds, hash));
    if (!response.isError) {
      setStatus(NEWSLETTER_CONFIMRATION_SUCCESS);
    } else {
      setError(errorMessageFromApi(response));
    }
  };

  const sendInvite = async (ids: string, email: string) => {
    setError("");
    setAlert("");
    const response = await post(NEWSLETTER_AGREEMENT(ids, email));
    if (!response.isError) {
      setAlert("Dziękujemy. Za chwilę, na Twojej skrzynce pojawi się mail - wejdź i potwierdź zapis do newslettera.");
    } else {
      setError(errorMessageFromApi(response));
    }
  };

  const resignNewsletter = async (ids: string, email: string) => {
    setError("");
    setAlert("");
    const response = await post(RESIGN_FROM_NEWSLETTER(ids, email));
    if (!response.isError) {
      setAlert("Udało Ci się zrezygnować z newslettera.");
    } else {
      setError(errorMessageFromApi(response));
    }
  };

  return { alert, error, status, onConfirm, sendInvite, resignNewsletter };
};
